import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { RelationMutateNavigation } from "../features/RelationMutateNavigation";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { Content } from "../../../general/modules/commons/content/content";
import useCrudTable from "../../../../hooks/useCrudTable";
import { Outlet, useParams } from "react-router-dom";
import { userColumns, userSchema } from "../../../user/domain/models/userModel";
import { Breadcrumb } from "../../../general/modules/commons/breadcrumb/breadcrumb";
import useCrudFilters from "../../../../hooks/useCrudFilters";
import { RelationAddExistingUser } from "../features/RelationAddExistingUser";
import { useAuthorization } from "../../../../hooks/useAuthorization";

export const RelationUsersPage = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");
  const { hasRole } = useAuthorization();
  const { id } = useParams();

  const { filters } = useCrudFilters({
    searchBy: "SearchByRootUser",
    fields: {
      relations: {
        fields: {
          id: {
            equal: id,
          },
        },
      },
    },
  });

  const crud = useCrudTable({
    prefix: "users",
    overrideTextPrefix: "employees",
    entity: "User",
    columns: userColumns,
    schema: userSchema,
    addAction: `/relations/edit/${id}/employees/add`,
    columnAction: `/relations/edit/${id}/employees/:id/edit`,
    queryExclude: ["password", "relation_id"],
    filters: id ? filters : undefined,
    defaultSorting: [
      {
        id: "name",
        desc: false,
      },
    ],
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={t("relation.mutate.employees")} />
          <Breadcrumb></Breadcrumb>
          <LayoutHeaderActions>
            <div className={"d-flex"}>
              {(hasRole("dbh-manager") || hasRole("super-admin")) && (
                <RelationAddExistingUser />
              )}
              {crud.addButton}
            </div>
          </LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <RelationMutateNavigation />
        <Content>
          <ContentHeader title={t("Employees")} />
          {crud.table}
        </Content>
        <Outlet />
      </LayoutContent>
    </Layout>
  );
};
